import Header from '@components/Shared/Layout/Header';
// import AuthenticationMethodsCard from '@components/ServerConfig/AuthenticationMethodsCard';
import ServerStatusCard from '@components/ServerConfig/ServerStatusCard';
import SessionExpirationCard from '@components/ServerConfig/SessionExpirationCard';
import { useLocalization } from '@lib/localization';
import { Box, Button } from '@mui/material';
import { type AllowedMethods, useGetConfigQuery, useUpdateConfigMutation } from '@store/api/rootEndpoints';
import { useAppSelector, useLoading } from '@store/hooks';
import { useEffect, useId, useState } from 'react';
import { CheckIcon } from 'react-line-awesome';

const ServerConfigPage = () => {
  const [sessionExpiresInSeconds, setSessionExpiresInSeconds] = useState<number>(0);
  const [allowedMethods, setAllowedMethods] = useState<AllowedMethods[]>([]);
  const { data } = useGetConfigQuery();
  const [updateConfig, { isLoading, error }] = useUpdateConfigMutation();
  const { show, hide } = useLoading();
  const { t } = useLocalization();

  const hasUpdatePermission = (useAppSelector((state) => state.auth).user?.role ?? 'user') == 'sysadmin';

  const componentId = useId();

  useEffect(() => {
    (isLoading ? show : hide)(componentId);
  }, [componentId, hide, isLoading, show]);

  useEffect(() => {
    setSessionExpiresInSeconds(data?.auth.sessionExpiresInSeconds ?? 0);
    setAllowedMethods(data?.auth.allowedMethods ?? []);
  }, [data, error]);

  const save = async () => {
    await updateConfig({ auth: { allowedMethods, sessionExpiresInSeconds } });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Header />
      <ServerStatusCard />
      <SessionExpirationCard value={sessionExpiresInSeconds} onChanged={setSessionExpiresInSeconds} />
      {/* <AuthenticationMethodsCard value={allowedMethods} onChanged={setAllowedMethods} /> */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={save}
          sx={{ px: 2 }}
          startIcon={<CheckIcon />}
          disabled={!hasUpdatePermission}
        >
          {t('Common_Save')}
        </Button>
      </Box>
    </Box >
  );
};

export default ServerConfigPage;
